import * as typeformEmbed from '@typeform/embed';

import { completeAndUpdateTour } from 'actions/feature-tour';
import { SHARE_TEAM_EXP_COMPLETE } from 'constants/events';
import { SHARE_WITH_LOOM_TEAM_COMPLETE } from 'constants/feature-tour';
import * as analytics from 'utilities/analytics';

import { store } from './store';

const onCompleteShareLoomForm = () => {
  store.dispatch(completeAndUpdateTour(SHARE_WITH_LOOM_TEAM_COMPLETE));

  analytics.track(SHARE_TEAM_EXP_COMPLETE, {
    shared: true,
  });
};

export const onCancelShareLoomForm = () => {
  store.dispatch(completeAndUpdateTour(SHARE_WITH_LOOM_TEAM_COMPLETE));

  analytics.track(SHARE_TEAM_EXP_COMPLETE, {
    shared: false,
  });
};

export const showShareLoomForm = () => {
  typeformEmbed.makePopup('https://useloom.typeform.com/to/U2Kv2a', {
    mode: 'popup',
    autoClose: 2,
    autoOpen: true,
    hideScrollbars: true,
    onSubmit: onCompleteShareLoomForm,
  });
};
